import DepartmentListPage from './list'
export default DepartmentListPage
